var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document--security_svg__clip0_61530_7277)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 22.5l-1.604-.76a3.767 3.767 0 01-2.146-3.39V13.5H21v4.85a3.766 3.766 0 01-2.146 3.39l-1.604.76zM15 15v3.35a2.26 2.26 0 001.288 2.034l.962.456.962-.456a2.26 2.26 0 001.288-2.033V15H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21H4.5V3h6v4.5A1.504 1.504 0 0012 9h4.5v2.25H18V7.5a.68.68 0 00-.225-.525l-5.25-5.25A.682.682 0 0012 1.5H4.5A1.504 1.504 0 003 3v18a1.504 1.504 0 001.5 1.5H12V21zm0-17.7l4.2 4.2H12V3.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document--security_svg__clip0_61530_7277"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocumentSecurity;